import React, { useEffect, useMemo, useState } from "react"
import { Col, Row, Card, Button, Steps, List, Avatar, Spin, Skeleton } from "antd"
import { useHistory } from "react-router-dom"
import { useGenericStore, useStore } from "hooks"
// import { FacebookProvider, useLogin } from "react-facebook"
// import { envKeys } from "config/envs.config"
import { general } from "store"
import toast from "lib/toast"
import axios from "axios"
import { endpoints } from "config/endpoints.config"
import request from "lib/request"
import FacebookLogin from "@greatsumini/react-facebook-login"
import { envKeys } from "config/envs.config"
import { isAldeia } from "hooks/useAldeia"
import StarAlert from "../StarAlert"
import ChannelCard from "../ChannelCard"
import { timeout } from "lib/helper"
import SearchEmpty from "components-old/shared/table/SearchEmpty"

const SkeletonCard = ({ i }: { i: number }) => {
  return (
    <ChannelCard
      key={i}
      name={
        <div className="mt-2 text-sm">
          <Skeleton.Input active style={{ height: 10, width: Math.random() * 60 + 20 }} className="rounded-xl" />
        </div>
      }
      onClick={() => {}}
      icon={<Skeleton.Avatar active size={44} />}
      index={i}
      style={{ height: 140 }}
      className="opacity-70 pointer-events-none size-full"
    />
  )
}

const SkeletonCards = () => {
  return (
    <>
      {Array.from({ length: 10 }).map((_, i) => (
        <SkeletonCard key={i} i={i} />
      ))}
    </>
  )
}

// {
//   data: [
//     {
//       id: "123",
//       name: "Raid Gaming",
//       picture: {
//         data: {
//           url: "https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/avatars/cd/cd2f911a6f2dee984e5f0dcd568b199cce8abc43_full.jpg",
//         },
//       },
//     },
//     {
//       id: "1234",
//       name: "Andrew Andr0dy",
//       picture: {
//         data: {
//           url: "https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/avatars/cd/cd5565e528b6d715bd61e724e5f74b55a99a7b16_full.jpg",
//         },
//       },
//     },
//     {
//       id: "1235",
//       name: "Stanleys hair",
//       picture: {
//         data: {
//           url: "https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/avatars/cd/cd85bbd9acee8f7a14804480083a9c937f61dbc7_full.jpg",
//         },
//       },
//     },
//   ],
// }

function Step2(props: { accessToken: string; type: "instagram" | "facebook"; onBack: () => void }) {
  const history = useHistory()
  const [pages, setPages] = useState<any>()
  const [loading, setLoading] = useState(-1)
  const [loadingPages, setLoadingPages] = useState(true)
  const { all: faceChannels } = useGenericStore((state) => state.channelsFacebook)

  const data = useMemo(() => {
    if (props.type === "facebook") {
      return pages?.data
    } else {
      return pages?.data?.filter((page: any) => page.instagram_business_account?.id) || []
    }
  }, [pages, props.type])

  async function getPages() {
    setLoadingPages(true)
    axios({
      method: "get",
      url: props.type === "facebook" ? endpoints.FACEBOOK_GRAPH_API + props.accessToken : endpoints.INSTAGRAM_GRAPH_API + props.accessToken,
    })
      .then((response) => {
        console.log(response)
        setPages(response.data)
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        setLoadingPages(false)
      })
  }

  useEffect(() => {
    getPages()
  }, [])

  const connectOnPage = (page: any) => {
    setLoading(page.id)
    request
      .save(props.type === "facebook" ? endpoints.FACEBOOK : endpoints.INSTAGRAM, {
        avatar: page.picture.data.url,
        ...(props.type === "instagram" && {
          pageInstagramId: page?.instagram_business_account?.id,
        }),
        pageId: page.id,
        name: page.name,
        accessToken: page.access_token,
        groupIds: [],
      })
      .then((response) => {
        toast.success(
          <span>
            Conectado ao canal de {props.type === "facebook" ? "Facebook" : "Instagram"} <strong>{response?.data.name}</strong>
          </span>,
        )
        history.push("/settings/channels")
      })
      .finally(() => {
        setLoading(-1)
      })
  }

  if (isAldeia) {
    if (!loadingPages && !data?.length) {
      return (
        <div className="flex-col pt-12 pb-24 text-center fc">
          <SearchEmpty className="w-52 h-52" />
          <span className="-mt-2 max-w-xs">Não encontramos nenhuma página com as permissões necessárias.</span>
          <br />
          <Button
            // type="primary"
            onClick={() => {
              props.onBack()
            }}
          >
            Tentar novamente
          </Button>
        </div>
      )
    }

    return (
      <div className="grid grid-cols-[repeat(auto-fit,_minmax(160px,_240px))] gap-2">
        {loadingPages && <SkeletonCards />}
        {!loadingPages &&
          data?.map((page: any, i) => {
            const isConnected = faceChannels.find((f) => f.pageId == page.id)
            const isLoading = loading == page.id

            return (
              <Spin spinning={false} className="size-full">
                <ChannelCard
                  key={page.id}
                  name={
                    <div className="flex flex-col gap-1 mt-1 text-sm" title={page.name}>
                      <div className="truncate max-w-[170px]">{page.name}</div>
                      <div className="absolute top-2 left-2 font-medium text-2xs">
                        <span className="px-1 rounded-full opacity-0 transition-all duration-200 text-content-300 border-separator-active-more group-hover:opacity-100">
                          #{page.id}
                        </span>
                      </div>
                    </div>
                  }
                  loading={isLoading}
                  onClick={() => {
                    connectOnPage(page)
                  }}
                  disabled={!!isConnected}
                  icon={<Avatar src={page?.picture?.data?.url} size={44} className={isLoading ? "opacity-30" : ""} />}
                  index={i}
                  style={{ height: 140 }}
                  className="group size-full"
                />
              </Spin>
            )
          })}
      </div>
    )
  }

  return (
    <List
      itemLayout="horizontal"
      dataSource={data}
      loading={loadingPages}
      renderItem={(page: any) => {
        const isConnected = faceChannels.find((f) => f.pageId == page.id)
        return (
          <Card style={{ width: "100%", marginBottom: 15 }} className="gray">
            <List.Item
              actions={[
                <Button
                  type="primary"
                  loading={loading == page.id}
                  disabled={!!isConnected}
                  onClick={(e) => {
                    connectOnPage(page)
                  }}
                >
                  {isConnected ? "Conectado" : "Conectar"}
                </Button>,
              ]}
            >
              <List.Item.Meta
                avatar={<Avatar src={page?.picture?.data?.url} size="large" />}
                title={page.name}
                description={page.id}
                style={{ alignItems: "center" }}
              />
            </List.Item>
          </Card>
        )
      }}
    />
  )
}

interface AddMetaChannelProps {
  type: "instagram" | "facebook"
}

function AddMetaChannel(props: AddMetaChannelProps) {
  const [step, setStep] = useState<0 | 1 | 2>(0)
  const [data, setData] = useState<{
    access_token: string
    token_type: string
    expires_in: number
  }>()

  const { _domain } = useStore(general)
  const appId = ((envKeys as any)[_domain.key] || {}).facebook_app_id || envKeys.staging.facebook_app_id
  const isStaging = _domain.key === "staging"

  const configId =
    props.type === "facebook" ? (isStaging ? "931498214790263" : "795441432613433") : isStaging ? "386730984278187" : "808306644819434"

  const stepAlerts = (
    <>
      {step == 0 && (
        <p>
          Vamos integrar sua página com o Kinbox. Para isso, clique no botão abaixo e habilite as páginas que você quer integrar no{" "}
          {props.type === "facebook" ? "Facebook" : "Instagram"} no popup que vai aparecer.
        </p>
      )}
      {step == 1 && <p>Selecione a página que você deseja conectar abaixo</p>}
    </>
  )

  return (
    <>
      {/* <Row justify="center" className="my-4">
        <Steps
          current={step}
          style={{ maxWidth: 600 }}
          className="[&_.ant-steps-item-process_.ant-steps-item-icon]:!bg-blue-600 [&_.ant-steps-item-finish_.ant-steps-item-icon]:!bg-blue-600"
        >
          <Steps.Step />
          <Steps.Step />
          <Steps.Step />
        </Steps>
      </Row> */}

      {isAldeia ? <StarAlert className="mt-2 mb-5">{stepAlerts}</StarAlert> : <p>{stepAlerts}</p>}

      {step == 0 && (
        <div>
          <br />
          <Row justify="center">
            <FacebookLogin
              appId={appId}
              scope={
                props.type === "facebook"
                  ? "pages_show_list, pages_messaging, pages_manage_metadata, business_management"
                  : "instagram_basic, pages_show_list, instagram_manage_messages, pages_manage_metadata, pages_messaging, business_management"
              }
              initParams={
                {
                  version: "v19.0",
                } as any
              }
              language="pt_BR"
              onSuccess={(response) => {
                setData({
                  ...response,
                  access_token: response.accessToken,
                } as any)
                setStep(1)
                console.log("Login Success!", response)
              }}
              onFail={(error) => {
                console.log("Login Failed!", error)
              }}
              onProfileSuccess={(response) => {
                console.log("Get Profile Success!", response)
              }}
              loginOptions={
                {
                  config_id: configId,
                } as any
              }
              render={({ onClick }) => (
                <Button
                  icon={<i className="text-lg fab fa-facebook shrink-0" />}
                  size="large"
                  onClick={onClick}
                  className="!bg-blue-600 hover:!bg-blue-700 !text-white !font-semibold"
                >
                  Conectar página do {props.type === "facebook" ? "Facebook" : "Instagram"}
                </Button>
              )}
            />
          </Row>
        </div>
      )}
      {step == 1 && <Step2 accessToken={data?.access_token!} type={props.type} onBack={() => setStep(0)} />}
      <br />
    </>
  )
}

export default AddMetaChannel
